































































































































































































































































































































































































































import Vue from 'vue'
import Header from '../components/Header.vue'
import SearchWarning from '../components/SearchWarning.vue'
import VideoResult from '../components/VideoResult.vue'
import ChannelResult from '../components/ChannelResult.vue'
import { searchVideos, searchVideoChannels } from '../shared/search'
import { getConfig } from '../shared/config'
import { pageToAPIParams, durationRangeToAPIParams, publishedDateRangeToAPIParams, extractTagsFromQuery, buildApiUrl } from '../shared/utils'
import { SearchUrl } from '../models'
import { EnhancedVideo } from '../../../server/types/video.model'
import { EnhancedVideoChannel } from '../../../server/types/channel.model'
import VueTagsInput from '@johmun/vue-tags-input'
import Pagination from '../components/Pagination.vue'
import { VideoChannelsSearchQuery, ResultList } from '../../../PeerTube/shared/models'
import Nprogress from 'nprogress'
import { VideosSearchQuery } from '../../../server/types/video-search.model'

export default Vue.extend({
  components: {
    'my-header': Header,
    'search-warning': SearchWarning,
    'video-result': VideoResult,
    'channel-result': ChannelResult,
    'vue-tags-input': VueTagsInput,
    'pagination': Pagination
  },

  data () {
    return {
      searchDone: false,

      indexName: '',
      instancesCount: 0,
      indexedInstancesUrl: '',
      results: [] as (EnhancedVideo | EnhancedVideoChannel)[],

      resultsCount: null as number,
      channelsCount: null as number,
      videosCount: null as number,

      searchedTerm: '',

      currentPage: 1,
      pages: [],
      resultsPerVideosPage: 10,
      resultsPerChannelsPage: 3,

      displayFilters: false,
      oldQuery: '',

      formSearch: '',
      formSort: '-match',

      formNSFW: undefined,
      formPublishedDateRange: undefined,
      formDurationRange: undefined,
      formCategoryOneOf: undefined,
      formLicenceOneOf: undefined,
      formLanguageOneOf: undefined,

      formTagAllOf: '',
      formTagOneOf: '',
      formTagsAllOf: [],
      formTagsOneOf: [],

      activeFilters: 0
    }
  },

  async mounted () {
    const config = await getConfig()

    this.instancesCount = config.indexedHostsCount
    this.indexedInstancesUrl = config.indexedInstancesUrl
    this.indexName = config.searchInstanceName

    if (Object.keys(this.$route.query).length !== 0) {
      // Speed up search done variable if the user came directly with a query
      // So it does not see the homepage for a few ms
      this.searchDone = true
      this.loadUrl()
      this.doSearch()
    }
  },

  watch: {
    // For pagination change
    $route(to, from) {
      const urlPage = this.$route.query.page

      const scrollToResults = urlPage && parseInt(urlPage) !== this.currentPage

      this.loadUrl()
      if (!this.formSearch) {
        this.simpleFormReset(false)
        this.scrollToTop()
        return
      }

      this.doSearch()
      if (scrollToResults) this.scrollToResults()
    },

    formSort () {
      this.doSearch()
    }
  },

  computed: {
    applyFiltersLabel () {
      return this.$gettext('Apply filters')
    },

    inputPlaceholder () {
      return this.$gettext('Keyword, channel, video, etc.')
    },

    tagsPlaceholder () {
      return this.$gettext('Add tag')
    },

    publishedDateRanges () {
      return  [
        {
          id: 'any_published_date',
          label: this.$gettext('Any')
        },
        {
          id: 'today',
          label: this.$gettext('Today')
        },
        {
          id: 'last_7days',
          label: this.$gettext('Last 7 days')
        },
        {
          id: 'last_30days',
          label: this.$gettext('Last 30 days')
        },
        {
          id: 'last_365days',
          label: this.$gettext('Last 365 days')
        }
      ]
    },

    durationRanges () {
      return [
        {
          id: 'any_duration',
          label: this.$gettext('Any')
        },
        {
          id: 'short',
          label: this.$gettext('Short (< 4 min)')
        },
        {
          id: 'medium',
          label: this.$gettext('Medium (4-10 min)')
        },
        {
          id: 'long',
          label: this.$gettext('Long (> 10 min)')
        }
      ]
    },

    videoCategories () {
      return [
        { id: '1', label: this.$gettext('Music') },
        { id: '2', label: this.$gettext('Films') },
        { id: '3', label: this.$gettext('Vehicles') },
        { id: '4', label: this.$gettext('Art') },
        { id: '5', label: this.$gettext('Sports') },
        { id: '6', label: this.$gettext('Travels') },
        { id: '7', label: this.$gettext('Gaming') },
        { id: '8', label: this.$gettext('People') },
        { id: '9', label: this.$gettext('Comedy') },
        { id: '10', label: this.$gettext('Entertainment') },
        { id: '11', label: this.$gettext('News & Politics') },
        { id: '12', label: this.$gettext('How To') },
        { id: '13', label: this.$gettext('Education') },
        { id: '14', label: this.$gettext('Activism') },
        { id: '15', label: this.$gettext('Science & Technology') },
        { id: '16', label: this.$gettext('Animals') },
        { id: '17', label: this.$gettext('Kids') },
        { id: '18', label: this.$gettext('Food') }
      ]
    },

    videoLicences () {
      return [
        { id: '1', label: this.$gettext('Attribution') },
        { id: '2', label: this.$gettext('Attribution - Share Alike') },
        { id: '3', label: this.$gettext('Attribution - No Derivatives') },
        { id: '4', label: this.$gettext('Attribution - Non Commercial') },
        { id: '5', label: this.$gettext('Attribution - Non Commercial - Share Alike') },
        { id: '6', label: this.$gettext('Attribution - Non Commercial - No Derivatives') },
        { id: '7', label: this.$gettext('Public Domain Dedication') }
      ]
    },

    videoLanguages () {
      return [
        { id: 'en', label: this.$gettext('English') },
        { id: 'fr', label: this.$gettext('Français') },
        { id: 'ja', label: this.$gettext('日本語') },
        { id: 'eu', label: this.$gettext('Euskara') },
        { id: 'ca', label: this.$gettext('Català') },
        { id: 'cs', label: this.$gettext('Čeština') },
        { id: 'eo', label: this.$gettext('Esperanto') },
        { id: 'el', label: this.$gettext('ελληνικά') },
        { id: 'de', label: this.$gettext('Deutsch') },
        { id: 'it', label: this.$gettext('Italiano') },
        { id: 'nl', label: this.$gettext('Nederlands') },
        { id: 'es', label: this.$gettext('Español') },
        { id: 'oc', label: this.$gettext('Occitan') },
        { id: 'gd', label: this.$gettext('Gàidhlig') },
        { id: 'zh', label: this.$gettext('简体中文（中国）') },
        { id: 'pt', label: this.$gettext('Português (Portugal)') },
        { id: 'sv', label: this.$gettext('svenska') },
        { id: 'pl', label: this.$gettext('Polski') },
        { id: 'fi', label: this.$gettext('suomi') },
        { id: 'ru', label: this.$gettext('русский') }
      ]
    },

    boostLanguagesQuery () {
      const languages = new Set<string>()

      for (const completeLanguage of navigator.languages) {
        const language = completeLanguage.split('-')[0]

        if (this.videoLanguages.find(vl => vl.id === language)) {
          languages.add(language)
        }
      }

      return Array.from(languages)
    },

    homeTitleMessage () {
      return this.$gettext('Display homepage')
    }
  },

  methods: {

    doNewSearch () {
      this.currentPage = 1
      this.channelsCount = null
      this.videosCount = null
      this.resultsCount = null

      this.updateUrl()
    },

    async doSearch () {
      // First search, scroll to top
      if (this.searchDone !== true) this.scrollToTop()

      this.results = []

      Nprogress.start()

      try {
        const [ videosResult, channelsResult ] = await Promise.all([
          this.searchVideos(),
          this.searchChannels()
        ])

        Nprogress.done()

        this.activeFilters = this.countActiveFilters()

        this.channelsCount = channelsResult.total
        this.videosCount = videosResult.total

        this.resultsCount = videosResult.total + channelsResult.total
        this.results = channelsResult.data.concat(videosResult.data)

        if (this.formSort === '-match') {
          this.results.sort((r1, r2) => {
            if (r1.score < r2.score) return 1
            else if (r1.score === r2.score) return 0

            return -1
          })
        }

        this.buildPages()
        this.searchDone = true
        this.searchedTerm = this.formSearch
      } catch (err) {
        console.error('Cannot do search.', err)
      } finally {
        Nprogress.done()
      }
    },

    isVideo (result: EnhancedVideo | EnhancedVideoChannel) {
      if ((result as EnhancedVideo).language) return true

      return false
    },

    getResultKey (result: EnhancedVideo | EnhancedVideoChannel) {
      if (this.isVideo(result)) return (result as EnhancedVideo).uuid

      return result.id + (result as EnhancedVideoChannel).host
    },

    updateUrl () {
      const query: SearchUrl = {
        search: this.formSearch,
        sort: this.formSort,
        nsfw: this.formNSFW,
        publishedDateRange: this.formPublishedDateRange,
        durationRange: this.formDurationRange,
        categoryOneOf: this.formCategoryOneOf,
        licenceOneOf: this.formLicenceOneOf,
        languageOneOf: this.formLanguageOneOf,
        tagsAllOf: this.formTagsAllOf.map(t => t.text),
        tagsOneOf: this.formTagsOneOf.map(t => t.text),
        page: this.currentPage
      }

      this.$router.push({ path: '/search', query })
    },

    loadUrl () {
      const query = this.$route.query as SearchUrl & { page: number }

      if (query.search) this.formSearch = query.search
      else this.formSearch = undefined

      if (query.nsfw) this.formNSFW = query.nsfw
      else this.formNSFW = undefined

      if (query.publishedDateRange) this.formPublishedDateRange = query.publishedDateRange
      else this.formPublishedDateRange = undefined

      if (query.durationRange) this.formDurationRange = query.durationRange
      else this.formDurationRange = undefined

      if (query.categoryOneOf) this.formCategoryOneOf = query.categoryOneOf
      else this.formCategoryOneOf = undefined

      if (query.licenceOneOf) this.formLicenceOneOf = query.licenceOneOf
      else this.formLicenceOneOf = undefined

      if (query.languageOneOf) this.formLanguageOneOf = query.languageOneOf
      else this.formLanguageOneOf = undefined

      if (query.tagsAllOf) this.formTagsAllOf = extractTagsFromQuery(query.tagsAllOf)
      else this.formTagsAllOf = []

      if (query.tagsOneOf) this.formTagsOneOf = extractTagsFromQuery(query.tagsOneOf)
      else this.formTagsOneOf = []

      if (query.sort) this.formSort = query.sort
      else this.formSort = '-match'

      if (query.page && this.currentPage !== query.page) {
        this.currentPage = parseInt(query.page + '')
      } else {
        this.currentPage = 1
      }
    },

    buildVideoSearchQuery () {
      const { start, count } = pageToAPIParams(this.currentPage, this.resultsPerVideosPage)
      const { durationMin, durationMax } = durationRangeToAPIParams(this.formDurationRange)
      const { startDate, endDate } = publishedDateRangeToAPIParams(this.formPublishedDateRange)

      const boostLanguages = this.boostLanguagesQuery

      return {
        search: this.formSearch,

        durationMin,
        durationMax,

        startDate,
        endDate,

        boostLanguages,

        nsfw: this.formNSFW || false,

        categoryOneOf: this.formCategoryOneOf ? [ this.formCategoryOneOf ] : undefined,
        licenceOneOf: this.formLicenceOneOf ? [ this.formLicenceOneOf ] : undefined,
        languageOneOf: this.formLanguageOneOf ? [ this.formLanguageOneOf ] : undefined,

        tagsOneOf: this.formTagsOneOf.map(t => t.text),
        tagsAllOf: this.formTagsAllOf.map(t => t.text),

        start,
        count,
        sort: this.formSort
      } as VideosSearchQuery
    },

    buildChannelSearchQuery () {
      const { start, count } = pageToAPIParams(this.currentPage, this.resultsPerChannelsPage)

      let sort: string
      if (this.formSort === '-matched') sort = '-matched'
      else if (this.formSort === '-publishedAt') sort = '-createdAt'
      else if (this.formSort === 'publishedAt') sort = 'createdAt'

      return {
        search: this.formSearch,
        start,
        sort,
        count
      } as VideoChannelsSearchQuery
    },

    searchVideos (): Promise<ResultList<EnhancedVideo>> {
      if (!this.formSearch) {
        return Promise.resolve({ data: [], total: 0 })
      }

      if (!this.hasStillMoreVideosResults()) {
        return Promise.resolve({ data: [], total: this.videosCount })
      }

      const query = this.buildVideoSearchQuery()

      return searchVideos(query)
    },

    searchChannels (): Promise<ResultList<EnhancedVideoChannel>> {
      if (!this.formSearch || this.isChannelSearchDisabled()) {
        return Promise.resolve({ data: [], total: 0 })
      }

       if (!this.hasStillChannelsResult()) {
        return Promise.resolve({ data: [], total: this.channelsCount })
      }

      const query = this.buildChannelSearchQuery()

      return searchVideoChannels(query)
    },

    hasStillChannelsResult () {
      // Not searched yet
      if (this.channelsCount === null) return true

      return this.getChannelsMaxPage() >= this.currentPage
    },

    hasStillMoreVideosResults () {
      // Not searched yet
      if (this.videosCount === null) return true

      return this.getVideosMaxPage() >= this.currentPage
    },

    getChannelsMaxPage () {
      return Math.ceil(this.channelsCount / this.resultsPerChannelsPage)
    },

    getVideosMaxPage () {
      return Math.ceil(this.videosCount / this.resultsPerVideosPage)
    },

    getMaxPage () {
      // Limit to 10 pages
      return Math.min(10, Math.max(this.getChannelsMaxPage(), this.getVideosMaxPage()))
    },

    buildPages () {
      this.pages = []

      for (let i = 1; i <= this.getMaxPage(); i++) {
        this.pages.push(i)
      }
    },

    toggleFilters () {
      this.displayFilters = !this.displayFilters
    },

    resetField (field: string) {
      if (field === 'nsfw') this.formNSFW = undefined
      else if (field === 'publishedDateRange') this.formPublishedDateRange = undefined
      else if (field === 'durationRange') this.formDurationRange = undefined
      else if (field === 'categoryOneOf') this.formCategoryOneOf = undefined
      else if (field === 'licenceOneOf') this.formLicenceOneOf = undefined
      else if (field === 'languageOneOf') this.formLanguageOneOf = undefined
      else if (field === 'tagsAllOf') this.formTagsAllOf = []
      else if (field === 'tagsOneOf') this.formTagsOneOf = []
    },

    simpleFormReset (searchDone = true) {
      this.formSearch = ''
      this.searchDone = searchDone
    },

    countActiveFilters () {
      let count = 0

      if (this.formNSFW) count++
      if (this.formPublishedDateRange) count++
      if (this.formDurationRange) count++
      if (this.formCategoryOneOf) count++
      if (this.formLicenceOneOf) count++
      if (this.formLanguageOneOf) count++
      if (this.formTagsAllOf && this.formTagsAllOf.length !== 0) count++
      if (this.formTagsOneOf && this.formTagsOneOf.length !== 0) count++

      return count
    },

    isChannelSearchDisabled () {
      return this.countActiveFilters() > 0
    },

    scrollToResults () {
      const anchor = document.getElementById('results-anchor')
      if (anchor) anchor.scrollIntoView()
    },

    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
})
